import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { SessionProvider } from "./session/SessionProvider";
import { ThemeProvider } from "./theme/ThemeProvider";
import "./theme/styles.css";

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<ThemeProvider>
			<BrowserRouter>
				<SessionProvider>
					<App />
				</SessionProvider>
			</BrowserRouter>
		</ThemeProvider>
	</StrictMode>,
);
